import { render, staticRenderFns } from "./leftComponent.vue?vue&type=template&id=53cac0db&scoped=true&"
import script from "./leftComponent.vue?vue&type=script&lang=js&"
export * from "./leftComponent.vue?vue&type=script&lang=js&"
import style0 from "./leftComponent.vue?vue&type=style&index=0&id=53cac0db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cac0db",
  null
  
)

export default component.exports